import { Button, FormControl, Grid, InputAdornment, InputLabel, Select, Table, TableBody, TableCell
    , TableRow, TextField, Typography, IconButton, Box } from '@mui/material';
import { Search as IconSearch, AddCircle as IconAddCircle
    , Delete as IconDelete } from "@mui/icons-material";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addPersonaDireccion, removePersonaDireccion, setDatoPersonaDireccion
    , setPersonaDirecciones, setTiposDirecciones, initPersonDirection, defaultPersonaDirecciones } from '../redux/personDirectionSlice';
import UbigeoAutocomplete from './common/UbigeoAutocomplete';
import UbigeoSearch from './UbigeoSearch';
import DirectionSearch from './DirectionSearch';
import DialogYesNo from './DialogYesNo';
import * as personaService from "../services/personaService";
import * as catalogoService from "../services/catalogoService";

const PersonDirection = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const isReadOnly = props.isReadOnly;

    useEffect(() => {
        dispatch(initPersonDirection({ sliceKey }));
    }, [dispatch, sliceKey]);

    const personaDirecciones = useSelector((state) => state.personDirection[sliceKey]?.personaDirecciones);
    const tiposDirecciones = useSelector((state) => state.personDirection[sliceKey]?.tiposDirecciones);

    const [verMasUbigeo, setVerMasUbigeo] = useState(true);
    const [openUbigeoSearch, setOpenUbigeoSearch] = useState(false);
    const openCloseUbigeoSearch = () => { setOpenUbigeoSearch(!openUbigeoSearch); };
    const [openDirectionSearch, setOpenDirectionSearch] = useState(false);
    const openCloseDirectionSearch = () => { setOpenDirectionSearch(!openDirectionSearch); };
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); };
    const [selectNumero, setSelectNumero] = useState(null);

    const fetchPersonaDirecciones = useCallback(async () => {
        const response = await personaService.getsPersonaDireccionView(props.id);

        if (response === null || response.length === 0)
            dispatch(setPersonaDirecciones({sliceKey: sliceKey, data: defaultPersonaDirecciones}));
        else
            dispatch(setPersonaDirecciones({sliceKey: sliceKey, data: response}));
    }, [props.id, sliceKey, dispatch]);

    const fetchTiposDirecciones = useCallback(async () => {
        const response = await catalogoService.getCatalogosByPadre(38);
        dispatch(setTiposDirecciones({sliceKey: sliceKey, data: response}));
    }, [sliceKey, dispatch]);

    useEffect(() => {
        fetchPersonaDirecciones();
        fetchTiposDirecciones();
    }, [fetchPersonaDirecciones, fetchTiposDirecciones]);

    const setItemValue = (numero, name, value) => {
        dispatch(setDatoPersonaDireccion({sliceKey: sliceKey, numero: numero, name: name, value: value}));
    };

    const setSelectUbigeoSearch = (selectUbigeoSearch) => {
        setItemValue(selectNumero, "idDireccion", 0);
        setItemValue(selectNumero, "idUbigeo", selectUbigeoSearch == null ? 0 : (selectUbigeoSearch.idUbigeo || selectUbigeoSearch.id || 0));
        setItemValue(selectNumero, "resumenUbigeo", selectUbigeoSearch == null ? "" : selectUbigeoSearch.descripcion);
    };
    const setSelectDirectionSearch = (selectDirectionSearch) => {
        setItemValue(selectNumero, "idUbigeo", selectDirectionSearch.idUbigeo);
        setItemValue(selectNumero, "resumenUbigeo", selectDirectionSearch.ubigeo);
        setItemValue(selectNumero, "idDireccion", selectDirectionSearch.id);
        setItemValue(selectNumero, "detalle", selectDirectionSearch.detalle);
        setItemValue(selectNumero, "referencia", selectDirectionSearch.referencia);
    };
    const deletePersonaDireccion = async () => {
        await personaService.deletePersonaDireccion(props.id, selectNumero);
        dispatch(removePersonaDireccion({sliceKey: sliceKey, numero: selectNumero}));
    };

    return (
        <Grid container>
            <Grid item>
                <Box display="flex" alignItems="center">
                    <Typography variant="h7">
                        <Box sx={{ fontWeight: 'bold' }} padding={0}>
                            {"Direcciones (" + (personaDirecciones?.length || 0) + ")"}
                        </Box>
                    </Typography>
                    <IconButton size="small" aria-label="agregar" style={{height: 10}} disabled={isReadOnly} onClick={() => {
                        dispatch(addPersonaDireccion(sliceKey));
                    }}>
                        <IconAddCircle />
                    </IconButton>
                    <Button size='small' color="primary" onClick={() => { setVerMasUbigeo(!verMasUbigeo); }}>
                        {verMasUbigeo ? "Ocultar Ubigeo" : "Mostrar Ubigeo"}
                    </Button>
                </Box>
            </Grid>
            <Grid container>
                <Table size="small">
                    <TableBody>
                        {
                            verMasUbigeo ?
                            personaDirecciones?.map((row, index) => (
                                <TableRow key={row.numero} sx={(theme) => ({
                                    backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                    "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                                })}>
                                    <TableCell>
                                        <Grid container spacing={1} padding={0} alignItems="center">
                                            <Grid item xs={6} sm={6} md={3} lg={2}>
                                                <FormControl required fullWidth disabled={isReadOnly}>
                                                    <InputLabel htmlFor="input-tipodireccion">Tipo Direccion</InputLabel>
                                                    <Select
                                                        native
                                                        label="Tipo Direccion"
                                                        value={row.idTipoDireccion || 0}
                                                        onChange={(event) => {
                                                            setItemValue(row.numero, "idTipoDireccion", event.target.value);
                                                        }}
                                                        inputProps={{
                                                            name: 'idTipoDireccion',
                                                            id: 'input-tipodireccion',
                                                        }}
                                                        size="small"
                                                    >
                                                        <option key={0} value={0}>{"(Seleccione)"}</option>
                                                        {tiposDirecciones?.map((item) => (
                                                            <option key={item.id} value={item.id}>{item.descripcion}</option>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={3} lg={3}>
                                                <UbigeoAutocomplete
                                                    name={`ubigeo-${row.numero}`}
                                                    label="Ubigeo / Distrito"
                                                    value={row.idUbigeo}
                                                    initialLabel={row.resumenUbigeo || ""}
                                                    disabled={isReadOnly}
                                                    onChange={(selected) => {
                                                        setItemValue(row.numero, "idUbigeo", selected ? selected.id : 0);
                                                        setItemValue(row.numero, "resumenUbigeo", selected ? selected.descripcion : "");
                                                        setItemValue(row.numero, "idDireccion", 0);
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={3} lg={4}>
                                                <TextField
                                                    required
                                                    name="detalle"
                                                    label="Detalle"
                                                    value={row.detalle || ""}
                                                    fullWidth
                                                    disabled={isReadOnly}
                                                    onChange={(event) => {
                                                        setItemValue(row.numero, "detalle", event.target.value);
                                                    }}
                                                    size="small"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton aria-label="Buscar Direccion" size="small" edge="end" disabled={isReadOnly} onClick={() => {
                                                                    setSelectNumero(row.numero);
                                                                    openCloseDirectionSearch();
                                                                }}>
                                                                    <IconSearch fontSize="small" />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={3} lg={3}>
                                                <Box display="flex" alignItems="center" gap={0}>
                                                    <TextField
                                                        name="referencia"
                                                        label="Referencia"
                                                        value={row.referencia || ""}
                                                        fullWidth
                                                        disabled={isReadOnly}
                                                        onChange={(event) => {
                                                            setItemValue(row.numero, "referencia", event.target.value);
                                                        }}
                                                        size="small"
                                                    />
                                                    <IconButton aria-label="borrar" size='small' disabled={isReadOnly} onClick={() => {
                                                        if (row.idPersona > 0) {
                                                            setSelectNumero(row.numero);
                                                            setOpenDialogDelete(true);
                                                        } else {
                                                            dispatch(removePersonaDireccion({sliceKey: sliceKey, numero: row.numero}));
                                                        }
                                                    }}>
                                                        <IconDelete />
                                                    </IconButton>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            )) :
                            personaDirecciones?.map((row, index) => (
                                <TableRow key={row.numero} sx={{
                                    ...(index % 2 === 1 && {
                                        backgroundColor: (theme) => theme.palette.action.selected,
                                    }),
                                    "&:last-child td, &:last-child th": {
                                        borderRadius: "0.5em",
                                    },
                                }}>
                                    <TableCell>
                                        <Grid container spacing={1} padding={0} alignItems="center">
                                            <Grid item xs={6} sm={6} md={3} lg={2}>
                                                <FormControl required fullWidth disabled={isReadOnly}>
                                                    <InputLabel htmlFor="input-tipodireccion">Tipo Direccion</InputLabel>
                                                    <Select
                                                        native
                                                        label="Tipo Direccion"
                                                        value={row.idTipoDireccion || 0}
                                                        onChange={(event) => {
                                                            setItemValue(row.numero, "idTipoDireccion", event.target.value);
                                                        }}
                                                        inputProps={{
                                                            name: 'idTipoDireccion',
                                                            id: 'input-tipodireccion',
                                                        }}
                                                        size="small"
                                                    >
                                                        <option key={0} value={0}>{"(Seleccione)"}</option>
                                                        {tiposDirecciones?.map((item) => (
                                                            <option key={item.id} value={item.id}>{item.descripcion}</option>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={5} lg={5}>
                                                <TextField
                                                    required
                                                    name="detalle"
                                                    label="Detalle"
                                                    value={row.detalle || ""}
                                                    fullWidth
                                                    disabled={isReadOnly}
                                                    onChange={(event) => {
                                                        setItemValue(row.numero, "detalle", event.target.value);
                                                    }}
                                                    size="small"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={4} lg={5}>
                                                <Box display="flex" alignItems="center" gap={0}>
                                                    <TextField
                                                        name="referencia"
                                                        label="Referencia"
                                                        value={row.referencia || ""}
                                                        fullWidth
                                                        disabled={isReadOnly}
                                                        onChange={(event) => {
                                                            setItemValue(row.numero, "referencia", event.target.value);
                                                        }}
                                                        size="small"
                                                    />
                                                    <IconButton aria-label="borrar" size='small' disabled={isReadOnly} onClick={() => {
                                                        if (row.idPersona > 0) {
                                                            setSelectNumero(row.numero);
                                                            setOpenDialogDelete(true);
                                                        }
                                                        else {
                                                            dispatch(removePersonaDireccion({sliceKey: sliceKey, numero: row.numero}));
                                                        }
                                                    }}>
                                                        <IconDelete />
                                                    </IconButton>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </Grid>
            <UbigeoSearch open={openUbigeoSearch} openClose={openCloseUbigeoSearch} setSelection={setSelectUbigeoSearch} />
            <DirectionSearch open={openDirectionSearch} openClose={openCloseDirectionSearch} setSelection={setSelectDirectionSearch} />
            <DialogYesNo open={openDialogDelete} openClose={openCloseDialogDelete} setYes={deletePersonaDireccion} 
                setNo={() => { return; }}
                titulo={"Borrar dirección"}
                texto={"Esta seguro de borrar la dirección?"} >
            </DialogYesNo>
        </Grid>
    );
};

export default PersonDirection;
